import { render, staticRenderFns } from "./Balances.vue?vue&type=template&id=55894582&"
import script from "./Balances.vue?vue&type=script&scoped=true&lang=js&"
export * from "./Balances.vue?vue&type=script&scoped=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports